import { throttle } from "throttle-debounce"
import { BREAKPOINTS } from '../constants.js'
import * as viewport from '../Utils/viewport.js'

export default function () {
    const pageNav = document.getElementsByClassName('PageNav')
    if (!pageNav.length || pageNav[0]?.dataset.js === 'PageNav' || $('body').hasClass('EpiEditMode')) return

    let mobileMenuButton = document.getElementById('mobile-menu')
    let primaryNav = document.getElementById('primary')
    let currScrollDir = 0;

    window.onload = function () {
        window.addEventListener("scroll", throttle(100, navScroll));
        transparentNavCheck(window.pageYOffset);
    }

    function navScroll() {
        if (window.innerWidth < BREAKPOINTS.mobile) return

        let headerNav = document.getElementsByClassName('PageNav')[0]  //get the height of the header...
        let headerNavHeight = headerNav.offsetHeight
        let currScrollPos = window.pageYOffset

        //console.log('currScrollDir::', currScrollDir)

        if ((currScrollDir < currScrollPos) && (currScrollPos > headerNavHeight)) {
            headerNav.classList.add('PageNav-isHidden')
            $('body').removeClass('PageNav--persist')
            $('#nav-main > li').removeClass('PageNav--persist-item')
        } else {
            headerNav.classList.remove('PageNav-isHidden')
        }

        $('.has-second-level.active').trigger('mouseleave');

        currScrollDir = currScrollPos;
        transparentNavCheck(currScrollPos);
    }

    function transparentNavCheck(currScrollPos) {
        if (document.body.classList.contains('has-floating-header')) {
            if (currScrollPos > 100) {
                document.body.classList.remove('is-transparent-nav');
            } else {
                document.body.classList.add('is-transparent-nav');
            }
        }
    }

    mobileMenuButton.addEventListener('click', function () {
        if (mobileMenuButton.classList.contains('active')) {
            document.body.classList.remove('nav-open')
            mobileMenuButton.classList.remove('active')
            primaryNav.classList.remove('active')
        } else {
            document.body.classList.add('nav-open')
            mobileMenuButton.classList.add('active')
            primaryNav.classList.add('active')
        }
    })

    $('#nav-main > li').off('click').on('click', function (e) {
        if (!viewport.isMobile()) {
            if (e.target.classList.contains('has-second-level')) {
                e.preventDefault();
                let $this = $(this)

                if (document.body.classList.contains('PageNav--persist')) {
                    $('body').removeClass('PageNav--persist')
                    $this.removeClass('PageNav--persist-item')
                    $this.find('>*').removeClass('active')
                    //let elem = $this
                    //let eType = e.type
                    //menuController(elem, eType)
                } else {
                    $('body').addClass('PageNav--persist')
                    $this.addClass('PageNav--persist-item')
                }
            }
        }
    });

    //mobile only...
    $('.has-second-level').off('click mouseenter').on('click', function (e) {
        if (viewport.isMobile()) {
            e.preventDefault();
            let elem = $(this)
            let eType = e.type
            menuController(elem, eType)
        }
    })

    $(document).on('mouseenter mouseleave', '#nav-main > li', function (e) {
        if (!viewport.isMobile()) {
            let elem = $(this)
            let eType = e.type
            menuController(elem, eType)
        }
    });

    function menuController(elem, eType) {
        let $this = (viewport.isMobile() ? elem : elem.find('.has-second-level'))
        let subMenuItems = document.querySelectorAll('.sub-menu-container')

        if (!$this.parent().hasClass('PageNav--persist-item')) {
            $('body').removeClass('PageNav--persist')
            $('#nav-main > li').removeClass('PageNav--persist-item')
        }

        function destroySubmenu() {
            $this.removeClass('active');
            $this.next().removeClass('active')
            document.body.classList.remove('menu-is-open')
            applyLeftPosition(subMenuItems, '0%');
        }

        function buildSubmenu() {
            $('body').addClass('menu-is-open')
            let els = document.querySelectorAll('.second-level.active')
            let thisEl = document.querySelectorAll('.has-second-level.active')

            removeClasses(els);
            removeClasses(thisEl);

            $this.addClass('active');
            $this.next().addClass('active');

            applyLeftPosition(subMenuItems, '-100%');
        }


        if (viewport.isMobile()) {
            if ($this.hasClass('active')) {
                destroySubmenu()
            } else {
                buildSubmenu()
            }
        } else {
            if (eType === 'mouseleave') {
                destroySubmenu()
            } else {
                buildSubmenu()
            }
        }

        if (primaryNav.classList.contains('is-open')) {
            primaryNav.classList.remove('is-open');
        } else {
            primaryNav.classList.add('is-open');
        }
    }

    function removeClasses(els) {
        for (var i = 0; i < els.length; i++) {
            els[i].classList.remove('active')
        }
    }

    $('.Button--back').off('click').on('click', function (e) {
        e.preventDefault()
        let elem = $(this).parents('li').find('>.has-second-level')
        let eType = e.type
        menuController(elem, eType)
    });

    function applyLeftPosition(els, pos) {
        for (var i = 0; i < els.length; i++) {
            els[i].style.left = pos;
        }
    }

}